import React, { useEffect, useState } from 'react';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const store_data = JSON.parse(store());
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const InitialData = {
        additional_charge_name: "",
        additional_charge_type: "",
        additional_charge_value: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/additional-charges/fetchSingle", { ...filter, user: store_data });
        const AdditionalChargesData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: AdditionalChargesData["id"],
                additional_charge_name: AdditionalChargesData["additional_charge_name"],
                additional_charge_type: AdditionalChargesData["additional_charge_type"],
                additional_charge_value: AdditionalChargesData["additional_charge_value"]
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if (is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])


    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        // Add validation logic
        let errors = [];
        if (!FormData.additional_charge_name) errors.push('Additional Charge Name is required.');
        if (!FormData.additional_charge_type) errors.push('Additional Charge Type is required.');
        if (!FormData.additional_charge_value) errors.push('Additional Charge Value is required.');
        else if (isNaN(FormData.additional_charge_value)) errors.push('Additional Charge Value must be a number.');
        setError(errors);
        if (errors.length > 0) {
            toast.error('Please fix validation errors.');
            return;
        }
        const payload = { org_id: store_data?.org_id, ...FormData }
        const response = await postAPI(is_edit ? "/additional-charges/update" : "/additional-charges/create", { ...payload, user: store_data });
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New Additional Charge Added Successfully.');
            window.location.reload()
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {
                Loading ?
                    <Loader />
                    :
                    (!isAdmin() && !canCreate && !canEdit) ? (
                        <div className="alert alert-danger">You do not have permission to access this form.</div>
                    ) : (
                        <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                            <div className="col-12 col-md-12">
                                <InputHandler form_data={FormData} setFormData={setFormData} Name="additional_charge_name" Type="text" Label="Additional Charge Name" />
                            </div>
                            {/* <div className="col-6 col-md-6">
                                <InputHandler form_data={FormData} setFormData={setFormData} Name="additional_charge_type" Type="text" Label="Additional Charge Type" />
                            </div> */}

                            <div className="col-12 col-md-6 mt-0">
                                <SelectBoxHandler Label="Charge Type" Options={[{ "label": "Percentage", "value": "PERCENTAGE" }, { "label": "Amount", "value": "AMOUNT" }]} Name="additional_charge_type" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                            </div>
                            <div className="col-6 col-md-6">
                                <InputHandler form_data={FormData} setFormData={setFormData} Name="additional_charge_value" Type="number" Label="Additional Charge Value" />
                            </div>
                            {Error.length > 0 && (
                                <div className="alert alert-danger">
                                    <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                                </div>
                            )}
                        </FormSubmissionHandler>
                    )
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
